import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    isParent: false,
};

export const ProgressSlice = createSlice({
    name: "progress",
    initialState: initialState,
    reducers: {
        loaderStateChange: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        resetLoaderState: () => {
            return initialState;
        },
    },
});

export const { loaderStateChange, resetLoaderState } = ProgressSlice.actions;

export default ProgressSlice.reducer;

export const selectProgress = (state) => state.ProgressReducer ?? {};
